export const formatDuration = (sec) => {
    if (!sec || sec <= 0) return "0s";
    const total = Math.round(Number(sec));
    const m = Math.floor(total / 60);
    const s = total % 60;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
};

export const formatRelative = (iso) => {
    if (!iso) return "—";
    const d = new Date(iso);
    const diffMs = Date.now() - d.getTime();
    const min = Math.round(diffMs / 60000);
    if (min < 1) return "just now";
    if (min < 60) return `${min}m ago`;
    const h = Math.round(min / 60);
    if (h < 24) return `${h}h ago`;
    const days = Math.round(h / 24);
    return `${days}d ago`;
};

export const formatDate = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleString(undefined, {
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

export const OUTCOME_LABELS = {
    appointment_booked: "Appointment",
    interested: "Interested",
    whitepaper_sent: "Whitepaper Sent",
    callback_requested: "Callback",
    not_interested: "Not Interested",
    no_answer: "No Answer",
    voicemail: "Voicemail",
    in_progress: "In Progress",
    failed: "Failed",
};

export const OUTCOME_COLORS = {
    appointment_booked: "#059669",
    interested: "#0033A0",
    whitepaper_sent: "#0EA5E9",
    callback_requested: "#D97706",
    not_interested: "#6B7280",
    no_answer: "#9CA3AF",
    voicemail: "#A855F7",
    in_progress: "#E02424",
    failed: "#DC2626",
};

export const SENTIMENT_COLORS = {
    positive: "#059669",
    neutral: "#6B7280",
    negative: "#E02424",
};
